import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {DigApi} from "@drop-in-gaming/core";
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <DigApi apiKey={"1"} organizationId={'1'} tld={'pro'} subdomain={'preprod'}>
            <App/>
        </DigApi>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
